module.exports = __webpack_public_path__ + "img/logo.8d4ad4d7.svg";